import { createElement } from "@max/max";
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Button from '@hfe/max-button';
import Sensor from '@max/mbc-sensor';
import Image from '@hfe/max-image';
import Price from '@max/leez-price';
import './index.scss';
import { useMonitorJumper } from '@nibfe/mcp-monitor-sdk';
import { getRankTagImage } from '../../utils/common';
export default function SuperGroupGoodsItem(props) {
    const { monitorNavigateToSmart } = useMonitorJumper();
    const { vo, onCardShow, index, onCardClick } = props;
    const { goodsName, goodsImage, goodsScore, goodsReview, goodsRecommendReason, goodsDetailUrl, goodsGiftList, goodsOriginalPrice, goodsSellPrice, promotionText, buttonExtraText, bottomTagImgSource } = vo;
    const rankNum = index + 1;
    const rankingImg = getRankTagImage(index);
    return <Sensor x-if={goodsSellPrice} once onAppear={() => {
            onCardShow(vo, index);
        }}>
      <Button className="super-group-goods-item__root-wrapper" onPress={() => {
            onCardClick(vo, index);
            monitorNavigateToSmart(goodsDetailUrl);
        }}>
        <View className="super-group-goods-item__left-wrapper">
          <Image className="super-group-goods-item__goods-img" source={{
            uri: goodsImage
        }} resizeMode="cover"/>
          {/** 榜单排名 */}
          <View className="super-group-goods-item__ranking-cntr">
            <Image className="super-group-goods-item__ranking-img" source={{
            uri: rankingImg
        }}/>
            <Text x-if={rankNum > 9} className="super-group-goods-item__ranking-text">{rankNum}</Text>
          </View>
          
          <Image className="super-group-goods-item__bottom-tag-img" source={bottomTagImgSource}/>
        </View>
        <View className="super-group-goods-item__right-wrapper">
          {/** 标题 */}
          <Text className="super-group-goods-item__name" numberOfLines={2}>
            {goodsName}
          </Text>
          {/** 评分、评价、位置 */}
          <View x-if={goodsScore || goodsReview || goodsRecommendReason} className="super-group-goods-item__info-wrapper">
            <View x-if={goodsScore || goodsReview} className="super-group-goods-item__info-left-wrapper">
              <View x-if={goodsScore} className="super-group-goods-item__rate-wrapper">
                <Text className="super-group-goods-item__rate-text">{goodsScore}</Text>
              </View>
              <View x-if={goodsReview} className="super-group-goods-item__review-wrapper">
                <Text className="super-group-goods-item__review-text">{goodsReview}</Text>
              </View>
            </View>
            <Text className="super-group-goods-item__position-text" numberOfLines={1}>
              {goodsRecommendReason}
            </Text>
          </View>
          {/** 超团信息 吃住享 */}
          <View className="super-group-goods-item__gift-list-wrapper">
            {goodsGiftList.map((giftItem, index) => {
            return <View className="super-group-goods-item__gift-item-wrapper" key={index}>
                  <Image className="super-group-goods-item__gift-item-img" source={{
                    uri: giftItem.giftIcon
                }}/>
                  <Text className="super-group-goods-item__gift-item-text" numberOfLines={1}>
                    {giftItem.giftText}
                  </Text>
                </View>;
        })}
          </View>
          {/** 价格信息 */}
          <View className="super-group-goods-item__price-wrapper">
            <Image className="super-group-goods-item__price-icon" source={{
            uri: 'https://p0.meituan.net/ingee/ca4ddf57d70aedfde32c017e5652cfbc10857.png'
        }}/>
            {/** 左边 */}
            <View className="super-group-goods-item__price-left-wrapper">
              {/** 价格相关 */}
              <View className="super-group-goods-item__price-info-wrapper">
                <View className="super-group-goods-item__sell-price-wrapper">
                  <Price fontWeightType="bold" content={goodsSellPrice} color="#FF2D19" type="l3"/>
                </View>
                <View className="super-group-goods-item__original-price-wrapper">
                  <Price x-if={goodsOriginalPrice} content={goodsOriginalPrice} crossed color="#888888" type="l7"/>
                </View>
              </View>
              {/** 降价文案 & 销量（爆品榜才展示） */}
              <Text className="super-group-goods-item__price-promotion-text" numberOfLines={1}>
                {promotionText}
              </Text>
            </View>
            {/** 右边 */}
            <View className="super-group-goods-item__price-right-wrapper">
              <Text className="super-group-goods-item__price-button-text">抢购</Text>
              <Text x-if={buttonExtraText} className="super-group-goods-item__price-button-extra-text" numberOfLines={1}>
                {buttonExtraText}
              </Text>
            </View>
          </View>
        </View>
      </Button>
    </Sensor>;
}
